import { useSelector } from 'react-redux'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'
import { useFeature } from '../features'
import { nlpIntentDescriptionSelector, knowledgeBaseByIdSelector } from './selectors'
import { sdkFeaturesSelector } from '../../features/hostingVersions/selectors/sdkFeaturesSelector'
import { RootState } from '../../reducers'

export function useAreNlpIntentsWithDescriptionEnabled(): boolean {
  const sdkFeatures = useSelector(sdkFeaturesSelector)
  return (
    !!useFeature('NLP_INTENTS_WITH_DESCRIPTION') &&
    sdkFeatures.includes(BotFeatures.NLP_INTENTS_WITH_DESCRIPTION)
  )
}

export function useIsNlpKbChatProviderEnabled(): boolean {
  const sdkFeatures = useSelector(sdkFeaturesSelector)
  return (
    !!useFeature('NLP_KB_CHAT_PROVIDER') && sdkFeatures.includes(BotFeatures.NLP_KB_CHAT_PROVIDER)
  )
}

export function useNlpIntentDescription(modelId: string, intentId: string): string | undefined {
  return useSelector(nlpIntentDescriptionSelector(modelId, intentId))
}

export const useKnowledgeBaseById = (knowledgeBaseId: string) => {
  return useSelector((state: RootState) => knowledgeBaseByIdSelector(knowledgeBaseId)(state))
}
